import { useInView } from '../../../hooks/useInView';

export default function SummitApproach() {
  const { ref: titleRef, inView: titleIn } = useInView();
  const { ref: cardsRef, inView: cardsIn } = useInView();

  const pillars = [
    {
      number: '01',
      title: 'Assess',
      description: 'We analyze your workflows, intake systems, revenue cycles, and operational friction points to map the full landscape of opportunity.',
    },
    {
      number: '02',
      title: 'Architect',
      description: 'We design structured AI frameworks tailored to your industry\'s compliance and performance standards — purpose-built, not templated.',
    },
    {
      number: '03',
      title: 'Elevate',
      description: 'We deploy, refine, and optimize systems that increase efficiency, conversion, and client retention with measurable outcomes.',
    },
  ];

  return (
    <section id="approach" className="bg-[#0a0f1c] py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-8">
        <div
          ref={titleRef}
          className={`mb-24 transition-all duration-700 ${titleIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-teal-400 text-xs font-semibold tracking-[0.2em] uppercase mb-5">Our Methodology</p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
            <h2 className="font-serif text-5xl lg:text-6xl font-bold text-white leading-tight max-w-2xl">
              Clarity. Structure.<br />Elevation.
            </h2>
            <p className="text-white/50 text-lg leading-relaxed max-w-md lg:text-right">
              We design intelligent operational frameworks that create measurable outcomes — without disrupting the core of your business.
            </p>
          </div>
        </div>

        <div ref={cardsRef} className="grid lg:grid-cols-3 gap-px bg-white/5 rounded-3xl overflow-hidden">
          {pillars.map((p, i) => (
            <div
              key={i}
              className={`bg-[#0d1526] p-12 transition-all duration-700 hover:bg-[#111d35] group ${cardsIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <div className="font-serif text-7xl font-bold text-white/5 group-hover:text-teal-500/10 transition-colors mb-8 select-none leading-none">
                {p.number}
              </div>
              <div className="w-8 h-px bg-teal-500 mb-8" />
              <h3 className="font-bold text-2xl text-white mb-4">{p.title}</h3>
              <p className="text-white/50 leading-relaxed text-base">{p.description}</p>
            </div>
          ))}
        </div>

        <div className={`mt-12 text-center transition-all duration-700 delay-500 ${titleIn ? 'opacity-100' : 'opacity-0'}`}>
          <p className="text-white/30 text-sm italic font-light">
            Every system is engineered to feel seamless, secure, and sustainable.
          </p>
        </div>
      </div>
    </section>
  );
}
